<nz-layout [ngClass]="(isLoggedIn && !isExternalPage) ? 'app-layout':'full-layout'">
  <nz-sider class="menu-sidebar" [nzTheme]="'light'" *ngIf="isLoggedIn && !isExternalPage"
   [nzCollapsible]="true" [(nzCollapsed)]="isCollapsed" (nzCollapsedChange)="onCollapse($event)" [nzWidth]="200">
    <app-sidebar [isCollapsed]="isCollapsed"></app-sidebar>
  </nz-sider>
  <nz-layout>
    <nz-content>
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>

<div class="quick-add-floting-button" *ngIf="isLoggedIn && !isExternalPage && !isFeedbackCapturing">
  <nz-float-button-group [nzIcon]="icon" nzType="primary" nzTrigger="hover" >
    <nz-float-button nz-tooltip nzTooltipTitle="Add Task" (click)="openQuickApp('task')" nzTooltipPlacement="left" [nzIcon]="taskIcon"></nz-float-button>
    <nz-float-button nz-tooltip nzTooltipTitle="Add Project" (click)="openQuickApp('project')" nzTooltipPlacement="left" [nzIcon]="projectIcon"></nz-float-button>
    <nz-float-button nz-tooltip nzTooltipTitle="Add Event" (click)="openQuickApp('event')" nzTooltipPlacement="left" [nzIcon]="calendarIcon"></nz-float-button>
    <nz-float-button nz-tooltip nzTooltipTitle="Add Client" (click)="openQuickApp('client')" nzTooltipPlacement="left" [nzIcon]="clientIcon"></nz-float-button>
  </nz-float-button-group>
  <ng-template #icon>
    <nz-icon nzType="plus" nzTheme="outline"></nz-icon>
  </ng-template>
  <ng-template #taskIcon>
    <nz-icon nzType="reconciliation" nzTheme="outline"></nz-icon>
  </ng-template>
  <ng-template #projectIcon>
    <nz-icon nzType="project" nzTheme="outline"></nz-icon>
  </ng-template>
  <ng-template #clientIcon>
    <nz-icon nzType="apartment" nzTheme="outline"></nz-icon>
  </ng-template>
  <ng-template #calendarIcon>
    <nz-icon nzType="calendar" nzTheme="outline"></nz-icon>
  </ng-template>
</div>

<button
  *ngIf="isLoggedIn && !isExternalPage"
  class="feedback-floating-button"
  [class.feedback-capture-hidden]="isFeedbackCapturing"
  type="button"
  (click)="openFeedbackModal()">
  <span class="feedback-floating-icon">
    <nz-icon nzType="comment" nzTheme="outline"></nz-icon>
  </span>
  <span class="feedback-floating-label">Feedback</span>
</button>

<nz-modal
  [(nzVisible)]="feedbackScreenshotVisible"
  nzTitle="Feedback Screenshot"
  [nzFooter]="null"
  [nzWidth]="666"
  [nzCentered]="true"
  nzClassName="feedback-choice-modal"
  (nzOnCancel)="closeFeedbackScreenshotModal()">
  <ng-container *nzModalContent>
    <div class="feedback-choice">
      <p class="feedback-choice-copy">Choose a type of screenshot for the feedback reference.</p>

      <div class="feedback-choice-grid">
        <button class="feedback-choice-card" type="button" (click)="selectFeedbackScreenshotMode('none')">
          <nz-icon nzType="stop" nzTheme="outline"></nz-icon>
          <span>No Picture</span>
        </button>
        <button class="feedback-choice-card" type="button" (click)="selectFeedbackScreenshotMode('generic')">
          <nz-icon nzType="picture" nzTheme="outline"></nz-icon>
          <span>Generic</span>
        </button>
        <button class="feedback-choice-card" type="button" (click)="selectFeedbackScreenshotMode('crop')">
          <nz-icon nzType="scissor" nzTheme="outline"></nz-icon>
          <span>Crop</span>
        </button>
      </div>

      <div class="feedback-choice-help">
        <p><strong>No Picture:</strong> Submit feedback without attaching any screenshot.</p>
        <p><strong>Generic:</strong> Submit feedback with a screenshot of the entire screen.</p>
        <p><strong>Crop:</strong> Submit feedback with a cropped screenshot of a specific section of the screen.</p>
      </div>
    </div>
  </ng-container>
</nz-modal>

<div
  *ngIf="isCropMode"
  class="feedback-crop-overlay"
  (mousedown)="startCropSelection($event)"
  (mousemove)="updateCropSelection($event)"
  (mouseup)="finishCropSelection()">
  <img class="feedback-crop-image" [src]="feedbackCapturedImage" alt="" draggable="false" />
  <div class="feedback-crop-instruction">Drag to select the screenshot area</div>
  <button class="feedback-crop-cancel" type="button" (mousedown)="$event.stopPropagation()" (click)="cancelCropMode()">Cancel</button>
  <div
    class="feedback-crop-selection"
    *ngIf="cropSelection.width > 0 && cropSelection.height > 0"
    [style.left.px]="cropSelection.x"
    [style.top.px]="cropSelection.y"
    [style.width.px]="cropSelection.width"
    [style.height.px]="cropSelection.height">
  </div>
</div>

<nz-modal
  [(nzVisible)]="feedbackVisible"
  nzTitle="Send Feedback"
  [nzFooter]="null"
  [nzMaskClosable]="!feedbackLoading"
  [nzClosable]="!feedbackLoading"
  [nzWidth]="feedbackScreenshots.length ? 1136 : 654"
  [nzCentered]="true"
  [nzClassName]="feedbackScreenshots.length ? 'feedback-form-modal feedback-form-modal-with-shot' : 'feedback-form-modal'"
  (nzOnCancel)="closeFeedbackModal()">
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="feedbackForm" nzLayout="vertical" class="feedback-form" (ngSubmit)="submitFeedback()">
      <div class="feedback-form-layout" [class.has-screenshot]="feedbackScreenshots.length">
        <div class="feedback-preview-panel" *ngIf="feedbackScreenshots.length">
          <img [src]="feedbackScreenshots[0]" alt="Feedback screenshot preview" />
        </div>

        <div class="feedback-fields">
          <nz-form-item>
            <nz-form-label>Name</nz-form-label>
            <nz-form-control nzErrorTip="Full name is required">
              <input nz-input formControlName="name" readonly />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label>Email</nz-form-label>
            <nz-form-control nzErrorTip="Please enter a valid official email">
              <input nz-input formControlName="email" type="email" readonly />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label nzRequired>Title</nz-form-label>
            <nz-form-control nzErrorTip="Feedback title is required">
              <input nz-input formControlName="title" placeholder="Short summary" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label nzRequired>Type</nz-form-label>
            <nz-form-control nzErrorTip="Feedback type is required">
              <nz-radio-group formControlName="type" class="feedback-type-group">
                <label nz-radio [nzValue]="2">Feature Required</label>
                <label nz-radio [nzValue]="1">Fix Required</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label nzRequired>Description</nz-form-label>
            <nz-form-control nzErrorTip="Feedback description is required">
              <textarea nz-input formControlName="comment" rows="5" placeholder="Tell us what's on your mind..."></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div class="feedback-modal-footer">
        <button nz-button type="button" (click)="closeFeedbackModal()" [disabled]="feedbackLoading">Cancel</button>
        <button nz-button nzType="primary" type="submit" [nzLoading]="feedbackLoading">Send</button>
      </div>
    </form>
  </ng-container>
</nz-modal>


@if(selectedQucik == 'task'){
  <app-task-drawer [data]="drawerData" [isVisible]="selectedQucik == 'task'" (closeDrawer)="close()" />
}
@if(selectedQucik == 'client'){
  <app-client-drawer [data]="drawerData"  [isVisible]="selectedQucik == 'client'" (closeDrawer)="close()" />
}
@if(selectedQucik == 'project'){
  <app-project-drawer [data]="drawerData" [isVisible]="selectedQucik == 'project'" (closeDrawer)="close()" />
}  

@if(selectedQucik == 'event'){
  <app-event-drawer [data]="drawerData" [isVisible]="selectedQucik == 'event'" (closeDrawer)="close()" (eventCreatedAndNavigate)="onEventCreatedAndNavigate($any($event))"></app-event-drawer>
}  

